module.exports = __webpack_public_path__ + "static/media/ic_report.692c51cc.svg";